const emailAddressRegex = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export default function emailAddressValidator(value: string) {
  if (typeof value !== 'string') return false;

  return value.search(emailAddressRegex) >= 0;
}
